// extracted by mini-css-extract-plugin
module.exports = {"container":"LoginPage_container__1_7A_","btn_submit":"LoginPage_btn_submit__2m9sg"};